<template>
    <v-container max-width="100%" style="margin-top: 2%;">
      <LoadingComponent :loading="loading" :message="loadingMessage" style="z-index: 1000;"></LoadingComponent>
      
      <ConfirmDeleteDialog
        v-model="confirmDialog"
        :title="$t('crudTemplatesMensagens.dialogs.confirmDelete.title')"
        :message="$t('crudTemplatesMensagens.dialogs.confirmDelete.message') + ' ' + deletedItem.titulo + '?'"
        :cancel-text="$t('crudTemplatesMensagens.dialogs.confirmDelete.cancel')"
        :confirm-text="$t('crudTemplatesMensagens.dialogs.confirmDelete.delete')"
        @cancel="closeDelete"
        @confirm="confirmDelete"
      />

      <merus-data-table
        :headers="headers"
        :items="templates"
        :loading="loading"
        :loading-text="$t('crudTemplatesMensagens.loading')"
        sort-by="id_template"
        dense
        class="elevation-7"
        :locale="$i18n.locale"
        style="border-radius: 10px; margin-top: 10px;"
        @update:displayedItems="displayedItemsForExport = $event"
    

 cod-tabela="TEMPLATESMENSAGENS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar
          :title="$t('crudTemplatesMensagens.title')"
          :token="token"
          :items="displayedItemsForExport !== null ? displayedItemsForExport : templates"
          :help-dialog-items="helpItems"
          :help-dialog-intro="helpDialogIntro"
          :help-dialog-title="helpDialogTitle"
          :csv-title="$tc('crudTemplatesMensagens.title')"
          :pdf-title="$tc('crudTemplatesMensagens.title')"
          :pdf-headers="headers"
          :pdf-filename="$tc('crudTemplatesMensagens.title')"
          :csv-headers="headers"
          hide-search
        >
          <template v-slot:add>
            <EditTemplateDialog
                ref="editTemplateDialogComponent"
                v-model="editDialog"
                :title="$t('crudTemplatesMensagens.form.title')"
                :edited-item.sync="editedItem"
                :variavel-description="variavelDescription"
                :variaveis-body="variaveisBody"
                :variaveis-rodape="variaveisRodape"
                :contador-variaveis-body="contadorVariaveisBody"
                :contador-variaveis-header="contadorVariaveisHeader"
                :contador-variaveis-rodape="contadorVariaveisRodape"
                :can-edit="canEdit"
                @update:canEdit="canEdit = $event"
                :can-delete="canDelete"
                @update:canDelete="canDelete = $event"
                :send-to-meta="sendToMeta"
                @update:sendToMeta="sendToMeta = $event"
                :superadmin="superadmin"
                :title-label="$t('crudTemplatesMensagens.form.fields.title')"
                :code-label="$t('crudTemplatesMensagens.form.fields.code')"
                :header-label="$t('crudTemplatesMensagens.form.fields.header')"
                :body-label="$t('crudTemplatesMensagens.form.fields.body')"
                :footer-label="$t('crudTemplatesMensagens.form.fields.footer')"
                :footer-hint="$t('crudTemplatesMensagens.form.fields.footerHint')"
                :editable-label="$t('crudTemplatesMensagens.form.fields.editable')"
                :deletable-label="$t('crudTemplatesMensagens.form.fields.deletable')"
                :send-to-meta-label="$t('crudTemplatesMensagens.form.fields.sendToMeta')"
                :add-variable-text="$t('crudTemplatesMensagens.form.addVariable')"
                :add-variables-text="$t('crudTemplatesMensagens.form.addVariables')"
                :variable-text="$t('crudTemplatesMensagens.form.variable')"
                :save-text="$t('button.save')"
                :form-valid.sync="formValidado"
                @close="closeEdit"
                @save="save"
                @filter-titulo="filterTitulo"
                @add-variable="adicionarVariavel"
                @delete-variable="deletarVariavel"
            />
          </template>
        </CadastroToolbar>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip 
          small 
          :color="getStatusColor(item.status)" 
          :text-color="item.status ? 'white' : 'grey'"
          v-if="item.status"
        >
          {{ item.status }}
        </v-chip>
        <span v-else class="grey--text">-</span>
      </template>

      <template v-slot:item.categoria="{ item }">
        <v-chip 
          small
          :color="getCategoryColor(item.categoria)" 
          outlined
          v-if="item.categoria"
        >
          {{ item.categoria }}
        </v-chip>
        <span v-else class="grey--text">-</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)"
          :disabled="!superadmin && item.can_edit == 0">mdi-pencil</v-icon>

        <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!superadmin && item.can_delete == 0"
          >mdi-delete</v-icon
        >
      </template>
    </merus-data-table>
    </v-container>
</template>

<script>

  import apiController from "@/utils/apiController";
  import LoadingComponent from "./LoadingComponent.vue";
  import DateUtils from "../utils/dateutils";
  import EventBus from "@/utils/eventBus";
  import MerusDataTable from './Tables/MerusDataTable.vue';
  import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
  import ConfirmDeleteDialog from './Dialogs/ConfirmDeleteDialog.vue';
  import EditTemplateDialog from './Dialogs/EditTemplateDialog.vue';
    
  export default {
    components: {
      LoadingComponent,
      MerusDataTable,
      CadastroToolbar,
      ConfirmDeleteDialog,
      EditTemplateDialog,
    },
    data: () => ({
    headers: [],
        user: null,
        superadmin: false,
        token: null, 
        loading: false,
        loadingDestinatarios: false,
        loadingEnviosMensagem: false,
        loadingEnviando: false,
        searchEnvios: "", 
        editDialog: false,
        confirmDialog: false,
        formValidado: false,
        templates: [],
        displayedItemsForExport: null,
        editedIndex: -1,
        metaSyncInterval: null,
        editedItem: {
            id_template: null,
            id_template_meta: null,
            cod_template: null,
            titulo: null,
            corpo: null,
            campos_descricao: null,
            campos_corpo: null,
            campos_rodape: null,
            can_delete: true,
            can_edit: true,
            sent_meta: false,
            dt_inclusao: null,
            dt_inclusao_extenso: null,
            id_usuario_inclusao: null,
            usuario_inclusao: null,
            dt_ultima_alteracao: null,
            dt_ultima_alteracao_extenso: null,
            id_usuario_ultima_alteracao: null,
            usuario_ultima_alteracao: null,
            descricao: null,
            rodape: null,
            status: null,
            categoria: null,
        },
        defaultItem: {
            id_template: null,
            id_template_meta: null,
            cod_template: null,
            titulo: null,
            corpo: null,
            campos_descricao: null,
            campos_corpo: null,
            campos_rodape: null,
            can_delete: true,
            can_edit: true,
            sent_meta: false,
            dt_inclusao: null,
            dt_inclusao_extenso: null,
            id_usuario_inclusao: null,
            usuario_inclusao: null,
            dt_ultima_alteracao: null,
            dt_ultima_alteracao_extenso: null,
            id_usuario_ultima_alteracao: null,
            usuario_ultima_alteracao: null,
            descricao: null,
            rodape: null,
            status: null,
            categoria: null,
        },
        deletedItem: {
            id_template: null,
            id_template_meta: null,
            cod_template: null,
            titulo: null,
            corpo: null,
            campos_descricao: null,
            campos_corpo: null,
            campos_rodape: null,
            can_delete: null,
            can_edit: null,
            sent_meta: null,
            dt_inclusao: null,
            dt_inclusao_extenso: null,
            id_usuario_inclusao: null,
            usuario_inclusao: null,
            dt_ultima_alteracao: null,
            dt_ultima_alteracao_extenso: null,
            id_usuario_ultima_alteracao: null,
            usuario_ultima_alteracao: null,
            descricao: null,
            rodape: null,
            status: null,
            categoria: null,
        },
        canDelete: true,
        canEdit: true,
        sendToMeta: false,
        contadorVariaveisBody: 1,
        contadorVariaveisHeader: 1,
        contadorVariaveisRodape: 1,
        variaveisBody: [],
        variavelDescription: [],
        variaveisRodape: [],
        loadingTemplateVariables: false,
    }),
    watch: {
        'editedItem.corpo': function(newVal) {
            if (this.loadingTemplateVariables) return;
            if (!newVal) {
                this.variaveisBody = [];
                return;
            }
            const regex = /\{\{(\d+)\}\}/g;
            const matches = [...newVal.matchAll(regex)];
            const currentVars = new Set(matches.map(m => parseInt(m[1])));
            const campo = 'campos_corpo';
            
            this.variaveisBody = this.variaveisBody.filter(v => currentVars.has(v.id));
            
            currentVars.forEach(id => {
                if (!this.variaveisBody.find(v => v.campo === campo && v.id === id)) {
                    this.variaveisBody.push({
                        campo: campo,
                        id: id,
                        key: `{{${id}}}`,
                        value: ''
                    });
                }
            });
            
            this.variaveisBody.sort((a, b) => a.id - b.id);
        },
        'editedItem.descricao': function(newVal) {
            if (this.loadingTemplateVariables) return;
            if (!newVal) {
                this.variavelDescription = [];
                return;
            }
            
            const regex = /\{\{(\d+)\}\}/g;
            const matches = [...newVal.matchAll(regex)];
            const currentVars = new Set(matches.map(m => parseInt(m[1])));
            const campo = 'campos_descricao';
             
            this.variavelDescription = this.variavelDescription.filter(v => currentVars.has(v.id));
            
            currentVars.forEach(id => {
                if (!this.variavelDescription.find(v => v.campo === campo && v.id === id)) {
                    this.variavelDescription.push({
                        campo: campo,
                        id: id,
                        key: `{{${id}}}`,
                        value: ''
                    });
                }
            });
            
            this.variavelDescription.sort((a, b) => a.id - b.id);
        },
        'editedItem.rodape': function(newVal) {
            if (this.loadingTemplateVariables) return;
            if (!newVal) {
                this.variaveisRodape = [];
                return;
            }
            const regex = /\{\{(\d+)\}\}/g;
            const matches = [...newVal.matchAll(regex)];
            const currentVars = new Set(matches.map(m => parseInt(m[1])));
            const campo = 'campos_rodape';

            this.variaveisRodape = this.variaveisRodape.filter(v => currentVars.has(v.id));

            currentVars.forEach(id => {
                if (!this.variaveisRodape.find(v => v.campo === campo && v.id === id)) {
                    this.variaveisRodape.push({
                        campo: campo,
                        id: id,
                        key: `{{${id}}}`,
                        value: ''
                    });
                }
            });

            this.variaveisRodape.sort((a, b) => a.id - b.id);
        },
        sendToMeta(enabled) {
            // Ao ligar envio à Meta, normaliza o título para o formato exigido
            if (enabled && this.editedItem && this.editedItem.titulo) {
                this.filterTitulo(this.editedItem.titulo);
            }
        },
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.editTemplateDialogComponent) {
                this.$refs.editTemplateDialogComponent.resetValidation();
            }
        }
    },
    computed: {
        loadingMessage() {
            return this.$t('crudTemplatesMensagens.loading');
        },
    helpItems() {
            const items = [
                {
                    title: this.$t('crudTemplatesMensagens.help.items.guidelines.title'),
                    description: this.$t('crudTemplatesMensagens.help.items.guidelines.description') 
                }
            ];
            
            return items;
        },
        helpDialogIntro() {
            return this.$t('crudTemplatesMensagens.help.intro') || 'Nesta seção você encontra informações sobre como utilizar as funcionalidades da tabela de templates de mensagens do sistema.';
        },
        helpDialogTitle() {
            return this.$t('crudTemplatesMensagens.help.title') || 'Ajuda - Templates de Mensagens';
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user")).id_usuario;
        this.superadmin = JSON.parse(sessionStorage.getItem("user")).is_superadmin == 1;
        this.token = sessionStorage.getItem("api");
        this.initialize();
        this.startMetaSync();
    },
    beforeDestroy() {
        this.stopMetaSync();
    },
    methods: {

        initialize() {
            this.populaTemplates();
        },
        startMetaSync() {
            // Sincronizar templates da Meta a cada 30 segundos
            this.metaSyncInterval = setInterval(() => {
                this.syncMetaTemplates();
            }, 5000);
        },
        stopMetaSync() {
            if (this.metaSyncInterval) {
                clearInterval(this.metaSyncInterval);
                this.metaSyncInterval = null;
            }
        },
        async populaTemplates() {
            this.loading = true;
            try {
                const response = await apiController.request(apiController.endpoints.getallTemplatesmensagens, { silent: true });

                this.templates = response.data;
                this.loading = false;
                
                // Sincronizar com Meta após carregar (sem recarregar novamente)
                await this.syncMetaTemplates(true);
            } catch (e) {
                this.loading = false;
                EventBus.$emit('show-error', { error: e });
            }
        },
        async syncMetaTemplates(silent = true) {
            try {
                const response = await apiController.request(apiController.endpoints.getallMetatemplates, { silent: true });

                if (!response.data.erro && response.data.templates) {
                    const metaTemplates = response.data.templates;
                    let hasUpdates = false;
                    
                    for (const template of this.templates) {
                        if (template.titulo) {
                            const metaTemplate = metaTemplates.find(mt => mt.name === template.titulo);
                            
                            if (metaTemplate && metaTemplate.id) {
                                const needsUpdate = 
                                    template.id_template_meta != metaTemplate.id ||
                                    template.status != metaTemplate.status ||
                                    template.categoria != metaTemplate.category;
                                
                                if (needsUpdate) {
                                    console.log(`[Meta Sync] Atualizando template "${template.titulo}":`, {
                                        id_template_meta: `${template.id_template_meta} → ${metaTemplate.id}`,
                                        status: `${template.status} → ${metaTemplate.status}`,
                                        categoria: `${template.categoria} → ${metaTemplate.category}`
                                    });
                                    
                                    await apiController.request(apiController.endpoints.updateTemplatemensagem, {
                                      data: {
                                        id_template: template.id_template,
                                        id_template_meta: metaTemplate.id,
                                        titulo: template.titulo,
                                        corpo: template.corpo,
                                        campos_descricao: template.campos_descricao,
                                        campos_corpo: template.campos_corpo,
                                        campos_rodape: template.campos_rodape,
                                        cod_template: template.cod_template,
                                        descricao: template.descricao,
                                        rodape: template.rodape,
                                        status: metaTemplate.status,
                                        categoria: metaTemplate.category,
                                        can_delete: template.can_delete,
                                        can_edit: template.can_edit,
                                        sent_meta: template.sent_meta,
                                        id_usuario_ultima_alteracao: this.user,
                                        dt_ultima_alteracao: DateUtils.getDateSQLFormatted(new Date())
                                      },
                                      silent: true,
                                    });
                                    
                                    template.id_template_meta = metaTemplate.id;
                                    template.status = metaTemplate.status;
                                    template.categoria = metaTemplate.category;
                                    hasUpdates = true;
                                    
                                    // Sincronizar mensagens que usam este template
                                    await this.syncMensagensWithTemplate(template.id_template);
                                }
                            }
                        }
                    }
                    
                    // Recarregar templates se houve atualizações
                    if (hasUpdates && !silent) {
                        await this.populaTemplates();
                    }
                }
            } catch (e) {
                console.error('Erro ao sincronizar templates com Meta:', e);
            }
        },
        async syncMensagensWithTemplate(idTemplate) {
            if (!idTemplate) {
                return;
            }
            
            try {
                await apiController.request(apiController.endpoints.syncMensagenswithtemplate, {
                    data: { id_template: idTemplate },
                    silent: true,
                });
            } catch (e) {
                // Silenciar erro
            }
        },
        async editItem(item) {
            // Verificar se o template está aprovado na Meta antes de permitir edição
            if (item.sent_meta) {
                this.loading = true;
                try {
                    const response = await apiController.request(apiController.endpoints.getApprovedmetatemplates, { silent: true });

                    if (!response.data.erro) {
                        const metaTemplates = response.data.templates;
                        const metaTemplate = metaTemplates.find(mt => mt.name === item.titulo && mt.status === 'APPROVED');
                        
                        if (!metaTemplate) {
                            this.loading = false;
                            EventBus.$emit('show-alert', { 
                                mensagem: this.$t('crudTemplatesMensagens.alerts.templateNotApproved'),
                                tipo: 'warning' 
                            });
                            return;
                        }
                    }
                } catch (e) {
                    this.loading = false;
                    EventBus.$emit('show-error', { error: e });
                    return;
                }
                this.loading = false;
            }
            
            this.editedIndex = this.templates.findIndex((t) => t.id_template == item.id_template);
            this.loadingTemplateVariables = true;
            this.editedItem = Object.assign({}, item);
            
            try {
                if (item.campos_corpo) {
                    const parsed = JSON.parse(item.campos_corpo);
                    if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].key) {
                        this.variaveisBody = parsed.map(p => ({
                            campo: 'campos_corpo',
                            id: parseInt(p.key.replace(/\D/g, '')),
                            key: p.key,
                            value: p.value || ''
                        })).sort((a, b) => a.id - b.id);
                    } else {
                        this.variaveisBody = [];
                        if (this.editedItem.corpo) {
                            const regex = /\{\{(\d+)\}\}/g;
                            const matches = [...this.editedItem.corpo.matchAll(regex)];
                            const ids = [...new Set(matches.map(m => parseInt(m[1])))].sort((a, b) => a - b);
                            
                            this.variaveisBody = ids.map(id => ({
                                campo: 'campos_corpo',
                                id: id,
                                key: `{{${id}}}`,
                                value: ''
                            }));
                        }
                    }
                } else {
                    this.variaveisBody = [];
                }
            } catch (e) {
                console.error("Error parsing campos_corpo", e);
                this.variaveisBody = [];
            }

            try {
                if (item.campos_descricao) {
                    const parsed = JSON.parse(item.campos_descricao);
                    if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].key) {
                        this.variavelDescription = parsed.map(p => ({
                            campo: 'campos_descricao',
                            id: parseInt(p.key.replace(/\D/g, '')),
                            key: p.key,
                            value: p.value || ''
                        })).sort((a, b) => a.id - b.id);
                    } else {
                        this.variavelDescription = [];
                        if (this.editedItem.descricao) {
                            const regex = /\{\{(\d+)\}\}/g;
                            const matches = [...this.editedItem.descricao.matchAll(regex)];
                            const ids = [...new Set(matches.map(m => parseInt(m[1])))].sort((a, b) => a - b);
                            
                            this.variavelDescription = ids.map(id => ({
                                campo: 'campos_descricao',
                                id: id,
                                key: `{{${id}}}`,
                                value: ''
                            }));
                        }
                    }
                } else {
                    this.variavelDescription = [];
                }
            } catch (e) {
                console.error("Error parsing campos_descricao", e);
                this.variavelDescription = [];
            }

            try {
                if (item.campos_rodape) {
                    const parsed = JSON.parse(item.campos_rodape);
                    if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].key) {
                        this.variaveisRodape = parsed.map(p => ({
                            campo: 'campos_rodape',
                            id: parseInt(p.key.replace(/\D/g, '')),
                            key: p.key,
                            value: p.value || ''
                        })).sort((a, b) => a.id - b.id);
                    } else {
                        this.variaveisRodape = [];
                        if (this.editedItem.rodape) {
                            const regex = /\{\{(\d+)\}\}/g;
                            const matches = [...this.editedItem.rodape.matchAll(regex)];
                            const ids = [...new Set(matches.map(m => parseInt(m[1])))].sort((a, b) => a - b);
                            this.variaveisRodape = ids.map(id => ({
                                campo: 'campos_rodape',
                                id: id,
                                key: `{{${id}}}`,
                                value: ''
                            }));
                        }
                    }
                } else {
                    this.variaveisRodape = [];
                }
            } catch (e) {
                console.error("Error parsing campos_rodape", e);
                this.variaveisRodape = [];
            }

            // Definir os valores dos switches
            this.canEdit = item.can_edit == 1;
            this.canDelete = item.can_delete == 1;
            this.sendToMeta = !!item.id_template_meta || item.sent_meta == 1;
            this.contadorVariaveisBody = (this.variaveisBody.length || 0) + 1;
            this.contadorVariaveisHeader = (this.variavelDescription.length || 0) + 1;
            this.contadorVariaveisRodape = (this.variaveisRodape.length || 0) + 1;
            
            // Forçar atualização e abrir dialog (após flush dos watchers do assign)
            this.$forceUpdate();
            this.$nextTick(() => {
                this.loadingTemplateVariables = false;
                this.editDialog = true;
            });
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.confirmDialog = true;
        },
        async save() {
            if (this.$refs.editTemplateDialogComponent) {
                this.$refs.editTemplateDialogComponent.validate();
            }
            if (this.formValidado) {
                if (this.variavelDescription.some(v => !v.value || v.value.trim() === '')) {
                    EventBus.$emit('show-alert', { 
                        mensagem: this.$t('crudTemplatesMensagens.alerts.emptyHeaderVariables'),
                        tipo: 'error' 
                    });
                    return;
                }
                if (this.variaveisBody.some(v => !v.value || v.value.trim() === '')) {
                    EventBus.$emit('show-alert', { 
                        mensagem: this.$t('crudTemplatesMensagens.alerts.emptyBodyVariables'),
                        tipo: 'error' 
                    });
                    return;
                }
                if (this.variaveisRodape.some(v => !v.value || v.value.trim() === '')) {
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('crudTemplatesMensagens.alerts.emptyFooterVariables'),
                        tipo: 'error'
                    });
                    return;
                }
                // Restrições de posição de variável no corpo valem só para templates Meta
                if (this.sendToMeta) {
                    if (this.editedItem.corpo && /^\{\{\d+\}\}/.test(this.editedItem.corpo)) {
                        EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.variableAtBeginning'),
                            tipo: 'error' 
                        });
                        return;
                    }
                    if (this.editedItem.corpo && /\{\{\d+\}\}\s*$/.test(this.editedItem.corpo)) {
                        EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.variableAtEnd'),
                            tipo: 'error' 
                        });
                        return;
                    }
                    if (this.variavelDescription.length > 1) {
                        EventBus.$emit('show-alert', {
                            mensagem: this.$t('crudTemplatesMensagens.alerts.metaHeaderSingleVariable'),
                            tipo: 'error'
                        });
                        return;
                    }
                    if (this.variaveisRodape.length > 0) {
                        EventBus.$emit('show-alert', {
                            mensagem: this.$t('crudTemplatesMensagens.alerts.metaFooterNoVariables'),
                            tipo: 'error'
                        });
                        return;
                    }
                }
                
                // Reordenar variáveis automaticamente antes de salvar
                if (this.editedItem.corpo) {
                    const resultado = this.reordenarVariaveis(this.editedItem.corpo);
                    this.editedItem.corpo = resultado.texto;
                    if (Object.keys(resultado.mapeamento).length > 0) {
                        this.reordenarValoresVariaveis(resultado.mapeamento, 'body');
                    }
                }
                if (!this.sendToMeta && this.editedItem.descricao) {
                    const resultadoHeader = this.reordenarVariaveis(this.editedItem.descricao);
                    this.editedItem.descricao = resultadoHeader.texto;
                    if (Object.keys(resultadoHeader.mapeamento).length > 0) {
                        this.reordenarValoresVariaveis(resultadoHeader.mapeamento, 'header');
                    }
                }
                if (!this.sendToMeta && this.editedItem.rodape) {
                    const resultadoRodape = this.reordenarVariaveis(this.editedItem.rodape);
                    this.editedItem.rodape = resultadoRodape.texto;
                    if (Object.keys(resultadoRodape.mapeamento).length > 0) {
                        this.reordenarValoresVariaveis(resultadoRodape.mapeamento, 'footer');
                    }
                }
                
                this.editedItem.campos_descricao = JSON.stringify(this.variavelDescription);
                this.editedItem.campos_corpo = JSON.stringify(this.variaveisBody);
                this.editedItem.campos_rodape = this.sendToMeta ? null : JSON.stringify(this.variaveisRodape);

                if (this.editedIndex === -1) {
                    this.editedItem.id_usuario_inclusao = this.user;
                    // Sempre sincronizar os valores dos switches
                    this.editedItem.can_delete = this.canDelete ? 1 : 0;
                    this.editedItem.can_edit = this.canEdit ? 1 : 0;
                    this.editedItem.sent_meta = this.sendToMeta ? 1 : 0;
                    
                    const templateExistente = this.templates.find(t => t.cod_template === this.editedItem.cod_template);
                    
                    if (templateExistente) {
                        EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.duplicateCode', { code: this.editedItem.cod_template }),
                            tipo: 'error' 
                        });
                        return;
                    }
                    
                    // Se opção de enviar para Meta estiver ativada, enviar PRIMEIRO para Meta
                    if (this.sendToMeta) {
                        await this.createTemplateInMetaFirst();
                    } else {
                        // Se não for enviar para Meta, criar localmente normalmente
                        apiController.request(apiController.endpoints.insertTemplatemensagem, {
                            data: this.editedItem,
                            onSuccess: async (response) => {
                                if (response.data.erro) {
                                    this.showResultado(true, response.data.mensagem);
                                    return;
                                }

                                // Inserção local bem-sucedida
                                this.showResultado(false, response.data.mensagem);

                                // Recarregar templates localmente
                                await this.populaTemplates();
                                this.closeEdit();
                            },
                        });
                    }
                } else {
                    const templateExistente = this.templates.find(t => 
                        t.cod_template === this.editedItem.cod_template && 
                        t.id_template !== this.editedItem.id_template
                    );
                    
                    if (templateExistente) {
                        EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.duplicateCode', { code: this.editedItem.cod_template }),
                            tipo: 'error' 
                        });
                        return;
                    }
                    
                    this.editedItem.id_usuario_ultima_alteracao = this.user;
                    this.editedItem.dt_ultima_alteracao = DateUtils.getDateSQLFormatted(new Date());
                    this.editedItem.can_delete = this.canDelete ? 1 : 0;
                    this.editedItem.can_edit = this.canEdit ? 1 : 0;
                    this.editedItem.sent_meta = this.sendToMeta ? 1 : 0;
                    
                    // Se opção de enviar para Meta estiver ativada, enviar/atualizar PRIMEIRO na Meta
                    if (this.sendToMeta) {
                        if (this.editedItem.id_template_meta) {
                            // Template já existe na Meta, atualizar na Meta primeiro
                            await this.updateTemplateInMetaFirst();
                        } else {
                            // Template não existe na Meta, criar na Meta primeiro
                            await this.createTemplateInMetaFirst();
                        }
                    } else {
                        // Se não for enviar para Meta, atualizar localmente normalmente
                        apiController.request(apiController.endpoints.updateTemplatemensagem, {
                            data: this.editedItem,
                            onSuccess: async (response) => {
                                if (response.data.erro) {
                                    this.showResultado(true, response.data.mensagem);
                                    return;
                                }

                                // Atualização local bem-sucedida
                                this.showResultado(false, response.data.mensagem);

                                // Sincronizar mensagens que usam este template
                                await this.syncMensagensWithTemplate(this.editedItem.id_template);

                                // Recarregar templates localmente
                                await this.populaTemplates();
                                this.closeEdit();
                            },
                        });
                    }
                }
            }
        },
        async createTemplateInMetaFirst() {
            this.loading = true;
            try {
                // 1. Enviar template para a Meta PRIMEIRO
                const sendResponse = await apiController.request(apiController.endpoints.sendTemplatetometa, {
                    data: {
                        titulo: this.editedItem.titulo,
                        descricao: this.editedItem.descricao,
                        corpo: this.editedItem.corpo,
                        rodape: this.editedItem.rodape,
                        campos_descricao: this.editedItem.campos_descricao,
                        campos_corpo: this.editedItem.campos_corpo
                    },
                    silent: true,
                });

                if (sendResponse.data.erro) {
                    this.loading = false;
                    const detalhes = sendResponse.data.detalhes;
                        if (detalhes && detalhes.error && detalhes.error.error_subcode === 2388293) {
                            EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.metaErrorProportionWordParameters'),
                            tipo: 'error' 
                            });
                        }
                        else {
                            EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.metaError'),
                            tipo: 'error' 
                            });
                        }
                    this.closeEdit();
                    return;
                }

                // 2. Pegar o ID do template criado na Meta
                const metaTemplateId = sendResponse.data.meta_template_id;
                
                // Aguardar um pouco para a Meta processar
                await new Promise(resolve => setTimeout(resolve, 2000));
                
                // 3. Buscar informações atualizadas do template na Meta
                let templateStatus = null;
                let templateCategoria = null;
                let attempts = 0;
                const maxAttempts = 3;
                
                while (attempts < maxAttempts && (!templateStatus || !templateCategoria)) {
                    attempts++;
                    console.log(`[Meta] Tentativa ${attempts} de buscar informações do template...`);
                    
                    try {
                        const metaTemplatesResponse = await apiController.request(apiController.endpoints.getallMetatemplates, { silent: true });

                        if (!metaTemplatesResponse.data.erro && metaTemplatesResponse.data.templates) {
                            const metaTemplate = metaTemplatesResponse.data.templates.find(
                                mt => mt.id === metaTemplateId || mt.name === this.editedItem.titulo
                            );
                            
                            if (metaTemplate) {
                                templateStatus = metaTemplate.status;
                                templateCategoria = metaTemplate.category;
                                console.log('[Meta] Template encontrado:', {
                                    id: metaTemplate.id,
                                    status: templateStatus,
                                    categoria: templateCategoria
                                });
                                break;
                            }
                        }
                    } catch (e) {
                        console.error(`[Meta] Erro na tentativa ${attempts}:`, e);
                    }
                    
                    if (attempts < maxAttempts) {
                        await new Promise(resolve => setTimeout(resolve, 2000));
                    }
                }
                
                // 4. AGORA criar localmente com os dados da Meta
                this.editedItem.id_template_meta = metaTemplateId;
                this.editedItem.status = templateStatus;
                this.editedItem.categoria = templateCategoria;
                this.editedItem.sent_meta = 1;
                
                const localResponse = await apiController.request(
                    this.editedIndex === -1
                        ? apiController.endpoints.insertTemplatemensagem
                        : apiController.endpoints.updateTemplatemensagem,
                    { data: this.editedItem, silent: true }
                );
                
                if (localResponse.data.erro) {
                    this.loading = false;
                    EventBus.$emit('show-alert', { 
                        mensagem: this.$t('crudTemplatesMensagens.alerts.localSaveError') + ': ' + localResponse.data.mensagem,
                        tipo: 'error' 
                    });
                    this.closeEdit();
                    return;
                }

                this.loading = false;
                
                // Mensagem de sucesso
                let mensagemSucesso = this.$t('crudTemplatesMensagens.alerts.metaSuccess');
                if (templateStatus === 'APPROVED') {
                    mensagemSucesso += ' ' + this.$t('crudTemplatesMensagens.alerts.templateApproved');
                } else if (templateStatus === 'PENDING') {
                    mensagemSucesso += ' ' + this.$t('crudTemplatesMensagens.alerts.templatePending');
                } else if (!templateStatus) {
                    mensagemSucesso += ' As informações serão sincronizadas automaticamente.';
                }

                EventBus.$emit('show-alert', { 
                    mensagem: mensagemSucesso,
                    tipo: 'success' 
                });

                // Recarregar templates e fechar
                await this.populaTemplates();
                this.closeEdit();
            } catch (error) {
                this.loading = false;
                EventBus.$emit('show-alert', { 
                    mensagem: this.$t('crudTemplatesMensagens.alerts.metaError'),
                    tipo: 'error' 
                });
                this.closeEdit();
            }
        },
        async updateTemplateInMetaFirst() {
            this.loading = true;
            try {
                // 1. Atualizar na Meta PRIMEIRO
                const metaResponse = await apiController.request(apiController.endpoints.updateMetatemplates, {
                    data: {
                        id_template_meta: this.editedItem.id_template_meta,
                        descricao: this.editedItem.descricao,
                        corpo: this.editedItem.corpo,
                        rodape: this.editedItem.rodape,
                        campos_descricao: this.editedItem.campos_descricao,
                        campos_corpo: this.editedItem.campos_corpo,
                        categoria: this.editedItem.categoria
                    },
                    silent: true,
                });
                
                if (metaResponse.data.erro) {
                    this.loading = false;
                    const detalhes = metaResponse.data.detalhes;
                    if (detalhes && detalhes.error && detalhes.error.error_subcode === 2388124) {
                        EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.metaUpdate24hLimit'),
                            tipo: 'warning' 
                        });
                    }
                    else if (detalhes && detalhes.error && detalhes.error.error_subcode === 2388293) {
                        EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.metaErrorProportionWordParameters'),
                            tipo: 'error' 
                        });
                    }
                    else {
                        EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.metaUpdateError') + ': ' + metaResponse.data.mensagem,
                            tipo: 'error' 
                        });
                    }
                    this.closeEdit();
                    return;
                }
                
                // 2. AGORA atualizar localmente
                const localResponse = await apiController.request(apiController.endpoints.updateTemplatemensagem, { data: this.editedItem, silent: true });

                if (localResponse.data.erro) {
                    this.loading = false;
                    EventBus.$emit('show-alert', { 
                        mensagem: this.$t('crudTemplatesMensagens.alerts.localUpdateError') + ': ' + localResponse.data.mensagem,
                        tipo: 'error' 
                    });
                    this.closeEdit();
                    return;
                }
                
                this.loading = false;
                
                // Sincronizar mensagens que usam este template
                await this.syncMensagensWithTemplate(this.editedItem.id_template);
                
                EventBus.$emit('show-alert', { 
                    mensagem: this.$t('crudTemplatesMensagens.alerts.metaUpdateSuccess'),
                    tipo: 'success' 
                });
                
                // Recarregar templates e fechar
                await this.populaTemplates();
                this.closeEdit();
            } catch (error) {
                this.loading = false;
                console.error('[Meta] Erro ao atualizar template na Meta primeiro:', error);
                EventBus.$emit('show-alert', { 
                    mensagem: this.$t('crudTemplatesMensagens.alerts.metaUpdateError'),
                    tipo: 'error' 
                });
                this.closeEdit();
            }
        },
        closeEdit() {
            this.editDialog = false;
            this.$nextTick(() => {
                this.loadingTemplateVariables = false;
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.sendToMeta = false;  
                this.canEdit = true;      
                this.canDelete = true;     
                this.contadorVariaveisBody = 1;
                this.contadorVariaveisHeader = 1;
                this.contadorVariaveisRodape = 1;
                this.variaveisBody = [];
                this.variavelDescription = [];
                this.variaveisRodape = [];
                if (this.$refs.editTemplateDialogComponent) {
                    this.$refs.editTemplateDialogComponent.resetValidation();
                }
            });
        },
        closeDelete() {
            this.deletedItem = Object.assign({}, this.defaultItem);
            this.confirmDialog = false;
        },
        async confirmDelete() {
            try {
                // Se o template tem ID da Meta, deletar primeiro da Meta
                if (this.deletedItem.id_template_meta) {
                    this.loading = true;
                    
                    try {
                        const metaResponse = await apiController.request(apiController.endpoints.deleteMetatemplates, {
                            data: { name_template_meta: this.deletedItem.titulo },
                            silent: true,
                        });
                        
                        if (metaResponse.data.erro) {
                            this.loading = false;
                            EventBus.$emit('show-alert', { 
                                mensagem: this.$t('crudTemplatesMensagens.alerts.metaDeleteError') + ': ' + metaResponse.data.mensagem,
                                tipo: 'error' 
                            });
                            return;
                        }
                    } catch (metaError) {
                        this.loading = false;
                        console.error('Erro ao deletar template na Meta:', metaError);
                        EventBus.$emit('show-alert', { 
                            mensagem: this.$t('crudTemplatesMensagens.alerts.metaDeleteError'),
                            tipo: 'error' 
                        });
                        return;
                    }
                }
                
                const response = await apiController.request(apiController.endpoints.deleteTemplatemensagem, { data: this.deletedItem, silent: true });

                this.loading = false;
                this.showResultado(response.data.erro, response.data.mensagem);
                this.populaTemplates();
                this.closeDelete();
            } catch (e) {
                this.loading = false;
                EventBus.$emit('show-error', { error: e });
            }
        },
        showResultado(erro, mensagem) {
            const tipo = erro ? "error" : "success";
            const mensagemFinal = mensagem || (erro ? this.$t('crudTemplatesMensagens.alerts.genericError') : this.$t('crudTemplatesMensagens.alerts.genericSuccess'));
            EventBus.$emit('show-alert', { mensagem: mensagemFinal, tipo });
        },
        getStatusColor(status) {
            if (!status) return 'grey';
            
            const statusColors = {
                'APPROVED': 'success',
                'PENDING': 'warning',
                'REJECTED': 'error',
                'DISABLED': 'grey',
                'PAUSED': 'orange',
                'IN_APPEAL': 'info',
                'DELETED': 'grey darken-2'
            };
            
            return statusColors[status] || 'blue-grey';
        },
        getCategoryColor(categoria) {
            if (!categoria) return 'grey';
            
            const categoryColors = {
                'UTILITY': 'blue',
                'MARKETING': 'purple',
                'AUTHENTICATION': 'teal',
                'OTP': 'cyan'
            };
            
            return categoryColors[categoria] || 'grey';
        },
        filterTitulo(value) {
            // Formatação Meta (underscores, sem espaços/acentos) só quando envia para a Meta
            if (!this.sendToMeta) {
                this.$nextTick(() => {
                    this.editedItem.titulo = value || '';
                });
                return;
            }

            let filtered = value ? value
                .replace(/[/\\\s]/g, '_')
                .replace(/[^a-zA-Z0-9_]/g, '') : '';
            
            this.$nextTick(() => {
                this.editedItem.titulo = filtered;
            });
        },
        reordenarVariaveis(texto) {
            if (!texto) return { texto: texto, mapeamento: {} };
            
            const regex = /\{\{(\d+)\}\}/g;
            const matches = [];
            let match;
            
            // Encontrar todas as variáveis com suas posições e números antigos
            while ((match = regex.exec(texto)) !== null) {
                matches.push({
                    index: match.index,
                    length: match[0].length,
                    original: match[0],
                    numeroAntigo: parseInt(match[1])
                });
            }
            
            if (matches.length === 0) return { texto: texto, mapeamento: {} };
            
            // Ordenar por posição no texto (da esquerda para direita)
            matches.sort((a, b) => a.index - b.index);
            
            // Criar mapeamento: número antigo -> novo número
            const mapeamento = {};
            matches.forEach((match, index) => {
                const novoNumero = index + 1;
                mapeamento[match.numeroAntigo] = novoNumero;
            });
            
            // Processar de trás para frente para evitar problemas com índices
            let resultado = texto;
            for (let i = matches.length - 1; i >= 0; i--) {
                const match = matches[i];
                const novoNumero = i + 1;
                const novaVariavel = `{{${novoNumero}}}`;
                const posicaoInicial = match.index;
                const posicaoFinal = posicaoInicial + match.length;
                
                resultado = resultado.slice(0, posicaoInicial) + novaVariavel + resultado.slice(posicaoFinal);
            }
            
            return { texto: resultado, mapeamento: mapeamento };
        },
        reordenarValoresVariaveis(mapeamento, tipo = 'body') {
            if (!mapeamento || Object.keys(mapeamento).length === 0) return;
            
            const campo = tipo === 'body'
                ? 'campos_corpo'
                : (tipo === 'footer' ? 'campos_rodape' : 'campos_descricao');
            const variaveis = tipo === 'body'
                ? this.variaveisBody
                : (tipo === 'footer' ? this.variaveisRodape : this.variavelDescription);
            if (!variaveis || variaveis.length === 0) return;
            
            let precisaReordenar = false;
            for (const numeroAntigo in mapeamento) {
                if (parseInt(numeroAntigo) !== mapeamento[numeroAntigo]) {
                    precisaReordenar = true;
                    break;
                }
            }
            
            if (!precisaReordenar) return;
            
            const novosValores = [];
            const valoresAntigos = {};
            
            variaveis.forEach(variavel => {
                valoresAntigos[variavel.id] = variavel.value;
            });
            
            const numerosOrdenados = Object.keys(mapeamento)
                .map(k => parseInt(k))
                .sort((a, b) => mapeamento[a] - mapeamento[b]);
            
            numerosOrdenados.forEach(numeroAntigo => {
                const novoNumero = mapeamento[numeroAntigo];
                novosValores.push({
                    campo: campo,
                    id: novoNumero,
                    key: `{{${novoNumero}}}`,
                    value: valoresAntigos[numeroAntigo] || ''
                });
            });
            
            if (tipo === 'body') {
                this.variaveisBody = novosValores;
            } else if (tipo === 'footer') {
                this.variaveisRodape = novosValores;
            } else {
                this.variavelDescription = novosValores;
            }
        },
        adicionarVariavel(contadorVariaveis, tipo, cursorPos = null) {
            if (tipo == 'body') {
                if (!this.editedItem.corpo) {
                    this.editedItem.corpo = '{{1}}';
                    this.contadorVariaveisBody = 2;
                    return;
                }
                
                const texto = this.editedItem.corpo || '';
                const variavelTemp = '{{0}}';
                
                let novoTexto;
                if (cursorPos !== null && cursorPos >= 0) {
                    novoTexto = texto.slice(0, cursorPos) + variavelTemp + texto.slice(cursorPos);
                } else {
                    novoTexto = texto + variavelTemp;
                }
                
                const resultado = this.reordenarVariaveis(novoTexto);
                this.editedItem.corpo = resultado.texto;
                this.reordenarValoresVariaveis(resultado.mapeamento, 'body');
                
                const quantidadeVariaveis = (this.editedItem.corpo.match(/\{\{\d+\}\}/g) || []).length;
                this.contadorVariaveisBody = quantidadeVariaveis + 1;
            } else if (tipo == 'header') {
                if (this.sendToMeta) {
                    const regex = /\{\{(\d+)\}\}/g;
                    if (this.editedItem.descricao !== null) {
                        const matches = [...this.editedItem.descricao.matchAll(regex)];
                        if (matches.length != 0) {
                           return 0;
                        }
                        
                        if (cursorPos !== null && cursorPos >= 0) {
                            const texto = this.editedItem.descricao || '';
                            this.editedItem.descricao = texto.slice(0, cursorPos) + '{{1}}' + texto.slice(cursorPos);
                        } else {
                            this.editedItem.descricao += '{{1}}';
                        }
                    } else {
                        this.editedItem.descricao = '{{1}}';
                    }
                    return;
                }

                if (!this.editedItem.descricao) {
                    this.editedItem.descricao = '{{1}}';
                    this.contadorVariaveisHeader = 2;
                    return;
                }

                const texto = this.editedItem.descricao || '';
                const variavelTemp = '{{0}}';
                let novoTexto;
                if (cursorPos !== null && cursorPos >= 0) {
                    novoTexto = texto.slice(0, cursorPos) + variavelTemp + texto.slice(cursorPos);
                } else {
                    novoTexto = texto + variavelTemp;
                }

                const resultado = this.reordenarVariaveis(novoTexto);
                this.editedItem.descricao = resultado.texto;
                this.reordenarValoresVariaveis(resultado.mapeamento, 'header');
                this.contadorVariaveisHeader = (this.editedItem.descricao.match(/\{\{\d+\}\}/g) || []).length + 1;
            } else if (tipo == 'footer') {
                if (this.sendToMeta) {
                    return;
                }
                if (!this.editedItem.rodape) {
                    this.editedItem.rodape = '{{1}}';
                    this.contadorVariaveisRodape = 2;
                    return;
                }

                const texto = this.editedItem.rodape || '';
                const variavelTemp = '{{0}}';
                let novoTexto;
                if (cursorPos !== null && cursorPos >= 0) {
                    novoTexto = texto.slice(0, cursorPos) + variavelTemp + texto.slice(cursorPos);
                } else {
                    novoTexto = texto + variavelTemp;
                }

                const resultado = this.reordenarVariaveis(novoTexto);
                this.editedItem.rodape = resultado.texto;
                this.reordenarValoresVariaveis(resultado.mapeamento, 'footer');
                this.contadorVariaveisRodape = (this.editedItem.rodape.match(/\{\{\d+\}\}/g) || []).length + 1;
            }
        },
        deletarVariavel(idVariavel, tipo) {
            if (tipo === 'body') {
                if (!this.editedItem.corpo) return;
                
                const texto = this.editedItem.corpo;
                const regex = new RegExp(`\\{\\{${idVariavel}\\}\\}`, 'g');
                const novoTexto = texto.replace(regex, '');
                
                const variaveisRestantes = (novoTexto.match(/\{\{\d+\}\}/g) || []).length;
                
                if (variaveisRestantes === 0) {
                    this.editedItem.corpo = novoTexto;
                    this.variaveisBody = [];
                    this.contadorVariaveisBody = 1;
                    return;
                }
                
                const resultado = this.reordenarVariaveis(novoTexto);
                this.editedItem.corpo = resultado.texto;
                
                if (Object.keys(resultado.mapeamento).length > 0) {
                    this.reordenarValoresVariaveis(resultado.mapeamento, 'body');
                } else {
                    const regexVars = /\{\{(\d+)\}\}/g;
                    const matches = [...resultado.texto.matchAll(regexVars)];
                    this.variaveisBody = matches.map(match => {
                        const id = parseInt(match[1]);
                        const variavelExistente = this.variaveisBody.find(
                            v => v.campo === 'campos_corpo' && v.id === id
                        );
                        return {
                            campo: 'campos_corpo',
                            id: id,
                            key: `{{${id}}}`,
                            value: variavelExistente ? variavelExistente.value : ''
                        };
                    }).sort((a, b) => a.id - b.id);
                }
                
                this.contadorVariaveisBody = (this.editedItem.corpo.match(/\{\{\d+\}\}/g) || []).length + 1;
            } else if (tipo === 'header') {
                if (!this.editedItem.descricao) return;

                if (this.sendToMeta) {
                    const texto = this.editedItem.descricao;
                    const regex = new RegExp(`\\{\\{${idVariavel}\\}\\}`, 'g');
                    this.editedItem.descricao = texto.replace(regex, '');
                    this.variavelDescription = [];
                    return;
                }

                const texto = this.editedItem.descricao;
                const regex = new RegExp(`\\{\\{${idVariavel}\\}\\}`, 'g');
                const novoTexto = texto.replace(regex, '');
                const variaveisRestantes = (novoTexto.match(/\{\{\d+\}\}/g) || []).length;

                if (variaveisRestantes === 0) {
                    this.editedItem.descricao = novoTexto;
                    this.variavelDescription = [];
                    this.contadorVariaveisHeader = 1;
                    return;
                }

                const resultado = this.reordenarVariaveis(novoTexto);
                this.editedItem.descricao = resultado.texto;
                if (Object.keys(resultado.mapeamento).length > 0) {
                    this.reordenarValoresVariaveis(resultado.mapeamento, 'header');
                }
                this.contadorVariaveisHeader = (this.editedItem.descricao.match(/\{\{\d+\}\}/g) || []).length + 1;
            } else if (tipo === 'footer') {
                if (!this.editedItem.rodape) return;

                const texto = this.editedItem.rodape;
                const regex = new RegExp(`\\{\\{${idVariavel}\\}\\}`, 'g');
                const novoTexto = texto.replace(regex, '');
                const variaveisRestantes = (novoTexto.match(/\{\{\d+\}\}/g) || []).length;

                if (variaveisRestantes === 0) {
                    this.editedItem.rodape = novoTexto;
                    this.variaveisRodape = [];
                    this.contadorVariaveisRodape = 1;
                    return;
                }

                const resultado = this.reordenarVariaveis(novoTexto);
                this.editedItem.rodape = resultado.texto;
                if (Object.keys(resultado.mapeamento).length > 0) {
                    this.reordenarValoresVariaveis(resultado.mapeamento, 'footer');
                }
                this.contadorVariaveisRodape = (this.editedItem.rodape.match(/\{\{\d+\}\}/g) || []).length + 1;
            }
        }
    }
}
</script>

<style scoped>
.truncate {
    max-width: 25vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>